import {
  CREATE_SUMMARY_GENERATOR_CONDITION_REQUEST,
  CREATE_SUMMARY_GENERATOR_CONDITION_SUCCESS,
  CREATE_SUMMARY_GENERATOR_CONDITION_FAIL,
  DETAIL_SUMMARY_GENERATOR_CONDITION_REQUEST,
  DETAIL_SUMMARY_GENERATOR_CONDITION_SUCCESS,
  DETAIL_SUMMARY_GENERATOR_CONDITION_FAIL,
  UPDATE_SUMMARY_GENERATOR_CONDITION_REQUEST,
  UPDATE_SUMMARY_GENERATOR_CONDITION_SUCCESS,
  UPDATE_SUMMARY_GENERATOR_CONDITION_FAIL
} from '../../../constants/summary-generator/summary-generator-conditions'

const initialState = {
  loading: false,
  summaryGeneratorCondition: {},
  error: null
}

const summaryGeneratorConditionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SUMMARY_GENERATOR_CONDITION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case CREATE_SUMMARY_GENERATOR_CONDITION_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        summaryGeneratorCondition: action.payload
      }
    case CREATE_SUMMARY_GENERATOR_CONDITION_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DETAIL_SUMMARY_GENERATOR_CONDITION_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        summaryGeneratorCondition: {}
      }
    case DETAIL_SUMMARY_GENERATOR_CONDITION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        summaryGeneratorCondition: action.payload
      }
    case DETAIL_SUMMARY_GENERATOR_CONDITION_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_SUMMARY_GENERATOR_CONDITION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_SUMMARY_GENERATOR_CONDITION_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        summaryGeneratorCondition: action.payload
      }
    case UPDATE_SUMMARY_GENERATOR_CONDITION_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default summaryGeneratorConditionReducer

